import { lazyRoute } from "@/routes/lazy-route";

const IndicatorLayout = lazyRoute(() => import("./$indicatorId/indicator.layout"), "IndicatorLayout");
const IndicatorPage = lazyRoute(() => import("./$indicatorId/indicator.page"), "IndicatorPage");
const IndicatorListLayout = lazyRoute(() => import("./indicator-list.layout"), "IndicatorListLayout");
const IndicatorListInnerLayout = lazyRoute(() => import("./indicator-list-inner.layout"), "IndicatorListInnerLayout");
const IndicatorListPage = lazyRoute(() => import("./indicator-list.page"), "IndicatorListPage");
const IndicatorTrashPage = lazyRoute(() => import("@/domain/trash/routes/indicator-trash.page"), "IndicatorTrashPage");

export const indicatorRoutes = [
  {
    path: "indicators",
    element: <IndicatorListLayout />,
    children: [
      {
        path: "",
        element: <IndicatorListInnerLayout />,
        children: [
          { path: "", element: <IndicatorListPage /> },
          { path: "trash", element: <IndicatorTrashPage /> },
        ],
      },
      {
        path: ":indicatorId",
        element: <IndicatorLayout />,
        children: [{ path: "", element: <IndicatorPage /> }],
      },
    ],
  },
];
